export enum MetricsType {
    REQUEST = 'REQUEST',
    RESPONSE = 'RESPONSE',
    COMPONENT = 'COMPONENT',
    BUTTON = 'BUTTON',
    TEXTFIELD = 'TEXTFIELD',
    SELECT = 'SELECT',
    DATEPICKER = 'DATEPICKER',
    RADIO = 'RADIO',
    CHECKBOX = 'CHECKBOX',
    COLLECTED_DATA = 'COLLECTED_DATA',
    WEBSOCKET = 'WEBSOCKET',
    NOTIFICATION = 'NOTIFICATION',
    PROCESS = 'PROCESS',
    ERROR = 'ERROR',
}
